// ─── Argentina Deposit Modal (CBU/CVU, push-detected) ────────────────────────
// Single-step informational modal opened from the ARS wallet card. Argentina
// payins on the NEW payments runtime are NOT user-initiated: the organization
// has a fixed receiving CVU (registered by staff, shared out-of-band by the
// account executive) and incoming ARS transfers — from a bank CBU or a wallet
// CVU — are detected and credited automatically by the provider webhook. The
// modal explains that flow and shows the latest detected deposits — it does
// not create anything (mirror of the Mexico SPEI modal).

import { ArgentinaDepositPanel } from "@/modules/dashboard/payins/components/ArgentinaDepositPanel";
import { ColocaButton } from "@/shared/components/buttons/ColocaButton";
import { ColocaDialog } from "@/shared/components/overlays/ColocaDialog";
import useTranslations from "@/shared/lang/useTranslations";

import { CURRENCY_TO_COUNTRY } from "../constants/wallets.constants";
import type { Wallet } from "../types/wallets-api.types";

export interface ArgentinaDepositModalProps {
  wallet: Wallet;
  open: boolean;
  onClose: () => void;
}

export function ArgentinaDepositModal({ wallet, open, onClose }: ArgentinaDepositModalProps) {
  const { t } = useTranslations("wallets");
  const countryName = CURRENCY_TO_COUNTRY[wallet.currency] ?? wallet.country;

  return (
    <ColocaDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
      size="lg"
      mobileFullscreen
      title={`${t("deposit_modal_title")} · ${wallet.currency}`}
      description={countryName}
    >
      <div className="space-y-4">
        <ArgentinaDepositPanel />
        <div className="flex justify-end border-t border-border pt-4">
          <ColocaButton variant="ghost" onClick={onClose}>
            {t("deposit_close")}
          </ColocaButton>
        </div>
      </div>
    </ColocaDialog>
  );
}
